<template>
  <div>
    <v-form v-model="valid" lazy-validation>
      <v-container :class="ui.bkgdColor">
        <v-layout row :class="ui.textSubheading">
          <div class="ml-4 mt-4">
            Profession or Trade
          </div>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs12 md8 lg6>
            <v-text-field
            :change="updateFormChar()"
            v-model="localForm.rpos"
            :rules="ruleMustBeFilledANDLessThan50"
            prepend-icon="work_outline"
            hint="role title"
            persistent-hint
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md8 lg6>
            <v-select
              :change="updateFormChar()"
              v-model="rtype"
              :label="this.localForm.rtype"
              :items="tradeOptionsType"
              color="wplblue0"
              prepend-icon="engineering"
              hint="Trade or profession"
              persistent-hint
            >
            </v-select>
          </v-flex>
        </v-layout>
        <v-layout row :class="ui.textSubheading">
          <div class="ml-4 mt-4 mb-2">
            Roles Description
          </div>
        </v-layout>
        <v-layout row wrap class="ml-3 mr-2">
          <v-flex xs10 offset-xs1>
            <v-textarea
            :change="updateFormChar()"
            :color="ui.textColor"
            :background-color="ui.btnColor"
            v-model="localForm.rdes"
            label="Role Description"
            :disabled="false"
            :outline="true"
            :rules="ruleMustBeNotUndefinedANDLessThan2000"
            hint="role description, experience, bio"
            auto-grow
            persistent-hint
            ></v-textarea>
          </v-flex>
        </v-layout>
        <v-layout row :class="ui.textSubheading">
          <div class="ml-4 mt-4">
            Employer Information
          </div>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs12 md8 lg6>
            <v-text-field
            :change="updateFormChar()"
            v-model="localForm.rct"
            :rules="ruleMustBeNotUndefinedANDLessThan50"
            prepend-icon="account_balance"
            hint="company name"
            persistent-hint
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md8 lg6>
            <v-text-field
            :change="updateFormChar()"
            v-model="localForm.rft"
            :rules="ruleMustBeNotUndefinedANDLessThan50"
            prepend-icon="place"
            hint="facility name"
            persistent-hint
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import ruleTextfield from "@/data/rules/mixins/rulesTextfield.js";
import tradeOptions from "@/data/options/mixins/tradeOptions.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      valid: true,
      localForm: {
        rdes: "",
        rpos: "",
        rtype: "",
        rct: "",
        rft: ""
      },
      orgForm: {
        rdes: "",
        rpos: "",
        rtype: "",
        rct: "",
        rft: ""
      },
      rtype: ""
    };
  },
  watch: {
    // whenever question changes, this function will run
    rtype() {
      this.localForm.rtype = this.rtype;
      this.updateFormChar();
    }
  },
  beforeMount() {
    // fix orginal data before change
    this.localForm.rct = this.getUser.char.rct;
    this.localForm.rft = this.getUser.char.rft;
    this.localForm.rpos = this.getUser.char.rpos;
    this.localForm.rtype = this.getUser.char.rtype;
    this.localForm.rdes = this.getUser.char.rdes;

    this.orgForm.rct = this.getUser.char.rct;
    this.orgForm.rft = this.getUser.char.rft;
    this.orgForm.rpos = this.getUser.char.rpos;
    this.orgForm.rtype = this.getUser.char.rtype;
    this.orgForm.rdes = this.getUser.char.rdes;
  },
  mixins: [docRevsModFunctions, ruleTextfield, apptheme, tradeOptions],
  computed: {
    ...mapGetters(["getDetailBasic", "getDetailChar"]),
    userStatus() {
      let status = null;
      if (this.getUserBasic.act === true) {
        status = "Active";
      } else {
        status = "Not Active";
      }
      return status;
    }
  },
  methods: {
    updateFormChar() {
      let char = this.getDetailChar;
      // eslint-disable-next-line
      if (
        this.localForm.rct !== this.orgForm.rct &&
        this.localForm.rct !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.rct = this.localForm.rct;
        // basic
        char.rct = this.localForm.rct;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.55, 1); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
      if (
        this.localForm.rft !== this.orgForm.rft &&
        this.localForm.rft !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.rft = this.localForm.rft;
        // basic
        char.rft = this.localForm.rft;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.55, 2); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
      if (
        this.localForm.rpos !== this.orgForm.rpos &&
        this.localForm.rpos !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.rpos = this.localForm.rpos;
        // basic
        char.rpos = this.localForm.rpos;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.55, 3); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
      if (this.localForm.rtype !== this.orgForm.rtype) {
        // after the change re-assign new Local to Org
        this.orgForm.rtype = this.localForm.rtype;
        // basic
        char.rtype = this.localForm.rtype;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.55, 4); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
      if (
        this.localForm.rdes !== this.orgForm.rdes &&
        this.localForm.rdes !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.rdes = this.localForm.rdes;
        // basic
        char.rdes = this.localForm.rdes;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.55, 5); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
    }
  }
};
</script>
